import { QueryClient } from '@tanstack/react-query'

/**
 * TanStack Query の QueryClient。read の標準キャッシュ層。
 * 方針の詳細は docs/design/async-react.md を参照。
 *
 * - `retry: false` — queryFn は正規化 union `{data, error, response}` を返し throw しない前提
 *   なので、HTTP エラーでは retry は発火しない（TQ から見て成功）。唯一 reject し得るのは実 API の
 *   network エラー（`*-api-fetch.ts` が未 try/catch）で、これは retry ではなく `toApiResult` の
 *   union 吸収で塞ぐ方針（async-react.md §エラーの扱い）。よって retry は off のままにする。
 * - `refetchOnWindowFocus: false` — Capacitor/PWA で前面復帰のたびに再 fetch すると無駄な通信に
 *   なるため無効化。他人/他端末由来の server 変更は staleTime 超過後のマウント時再取得と
 *   `refetchOnReconnect`（オンライン復帰時、既定 true）で拾う。自分の mutation は
 *   `invalidateQueries` の片方向ブリッジで即時反映する。
 * - `staleTime` は一覧/メタデータ系の暫定既定。種別ごとの本格チューニングは per-query で後続に。
 */
export const createQueryClient = (): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
    },
  })

/** アプリ用の安定インスタンス。テストはテストごとに createQueryClient() を使う。 */
export const queryClient = createQueryClient()
